/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
import {
  RioComponentCheckboxFragmentDoc,
  RioComponentDateFragmentDoc,
  RioComponentDateTimeFragmentDoc,
  RioComponentExternalLinkFragmentDoc,
  RioComponentGeolocationFragmentDoc,
  RioComponentOptionsFragmentDoc,
  RioComponentPassFailFragmentDoc,
  RioComponentRadioButtonGroupFragmentDoc,
  RioComponentSimpleFragmentDoc,
  RioComponentStaticValueFragmentDoc,
  RioComponentStatusFragmentDoc,
  RioComponentTextAreaFragmentDoc,
  RioComponentTroublemakerFragmentDoc,
  RioRuleFragmentDoc,
  RioTemplateFragmentDoc,
} from './RioLatestTemplate.hook'
import {
  RioAttachmentFragmentDoc,
  RioReducedReportFragmentDoc,
} from './RioReport.hook'
import {
  RioBackofficeUserFragmentDoc,
  RioEmployeeFragmentDoc,
  RioUserFragmentDoc,
} from './RioUserFragment.hook'

const defaultOptions = {} as const
export type RioReportsQueryVariables = Types.Exact<{
  input: Types.RioReportsInput
}>

export type RioReportsQuery = {
  __typename?: 'Query'
  rioReports: {
    __typename?: 'RioReportsResponse'
    reports: Array<{
      __typename?: 'RioReport'
      reportId: string
      shortId: string
      version: number
      versionCreatedAt: string
      initialVersionCreatedAt: string
      versionCreatedBy: {
        __typename?: 'RioUser'
        backofficeUser: {
          __typename?: 'BackofficeUser'
          id: string
          firstName: string
          lastName: string
        } | null
        employee: {
          __typename?: 'Employee'
          id: string
          firstName: string | null
          lastName: string | null
        } | null
      }
      template: { __typename?: 'RioTemplate'; id: string; version: number }
      initialVersionCreatedBy: {
        __typename?: 'RioUser'
        backofficeUser: {
          __typename?: 'BackofficeUser'
          id: string
          firstName: string
          lastName: string
        } | null
        employee: {
          __typename?: 'Employee'
          id: string
          firstName: string | null
          lastName: string | null
        } | null
      }
      values: Array<{
        __typename?: 'RioValue'
        componentId: string
        value: string
      }>
      attachments: Array<{
        __typename?: 'RioAttachment'
        attachmentId: string
        uploadedAt: string
        photoCategory: Types.RioPhotoCategory | null
        fileName: string
        attachmentType: Types.RioAttachmentType | null
        size: number
        uploadedBy: {
          __typename?: 'RioUser'
          backofficeUser: {
            __typename?: 'BackofficeUser'
            id: string
            firstName: string
            lastName: string
          } | null
          employee: {
            __typename?: 'Employee'
            id: string
            firstName: string | null
            lastName: string | null
          } | null
        } | null
      }> | null
      region: { __typename?: 'Region'; id: string }
    }> | null
    listViewConfig: {
      __typename?: 'RioListViewConfig'
      tenant: string
      category: Types.RioCategory
      columns: Array<{
        __typename?: 'RioListViewColumnMapping'
        columnType: Types.RioListViewColumnType
        initialSortColumn: Types.SortOrder | null
        componentIdValue: Array<string> | null
        componentIdLink: Array<string> | null
        reportAttribute: string | null
        columnSize: number
        label: { __typename?: 'RioLabel'; en: string | null; de: string | null }
      }>
      filters: Array<{
        __typename?: 'RioListViewFilter'
        componentType: Types.RioComponentType
        domainIdentifier: Types.RioDomainIdentifier | null
        showSelectedLabel: boolean | null
        label: { __typename?: 'RioLabel'; en: string | null; de: string | null }
        filterConfigs: Array<{
          __typename?: 'RioFilterConfig'
          value: string
          label: {
            __typename?: 'RioLabel'
            en: string | null
            de: string | null
          }
        }> | null
      }>
    } | null
    usedTemplates: Array<{
      __typename?: 'RioTemplate'
      id: string
      category: Types.RioCategory
      name: string
      tenant: string
      supportedFleets: Array<string> | null
      version: number
      immutable: boolean | null
      title: {
        __typename?: 'RioLabel'
        de: string | null
        en: string | null
      } | null
      newReportTitle: {
        __typename?: 'RioLabel'
        en: string | null
        de: string | null
      } | null
      editReportTitle: {
        __typename?: 'RioLabel'
        en: string | null
        de: string | null
      } | null
      viewReportTitle: {
        __typename?: 'RioLabel'
        en: string | null
        de: string | null
      } | null
      components: Array<
        | {
            __typename: 'RioComponentCheckbox'
            componentId: string
            componentType: Types.RioComponentType
            dependingComponentIds: Array<string> | null
            domainIdentifier: Types.RioDomainIdentifier | null
            overrideFailValue: boolean | null
            topDivider: boolean | null
            label: {
              __typename?: 'RioLabel'
              de: string | null
              en: string | null
            }
            description: {
              __typename?: 'RioLabel'
              en: string | null
              de: string | null
            } | null
            checkboxLabel: {
              __typename?: 'RioLabel'
              en: string | null
              de: string | null
            } | null
            trueLabel: {
              __typename?: 'RioLabel'
              en: string | null
              de: string | null
            }
            falseLabel: {
              __typename?: 'RioLabel'
              en: string | null
              de: string | null
            }
            viewLabel: {
              __typename?: 'RioLabel'
              en: string | null
              de: string | null
            } | null
          }
        | {
            __typename: 'RioComponentDate'
            componentId: string
            componentType: Types.RioComponentType
            dependingComponentIds: Array<string> | null
            domainIdentifier: Types.RioDomainIdentifier | null
            allowFutureDates: boolean | null
            label: {
              __typename?: 'RioLabel'
              de: string | null
              en: string | null
            }
          }
        | {
            __typename: 'RioComponentDateTime'
            componentId: string
            componentType: Types.RioComponentType
            dependingComponentIds: Array<string> | null
            domainIdentifier: Types.RioDomainIdentifier | null
            context: Types.RioDateTimeContext | null
            allowFutureDates: boolean | null
            label: {
              __typename?: 'RioLabel'
              de: string | null
              en: string | null
            }
          }
        | {
            __typename: 'RioComponentExpirationTime'
            componentId: string
            componentType: Types.RioComponentType
            dependingComponentIds: Array<string> | null
            domainIdentifier: Types.RioDomainIdentifier | null
            label: {
              __typename?: 'RioLabel'
              de: string | null
              en: string | null
            }
          }
        | {
            __typename: 'RioComponentExternalLink'
            componentId: string
            componentType: Types.RioComponentType
            dependingComponentIds: Array<string> | null
            domainIdentifier: Types.RioDomainIdentifier | null
            label: {
              __typename?: 'RioLabel'
              de: string | null
              en: string | null
            }
            placeholder: {
              __typename?: 'RioLabel'
              en: string | null
              de: string | null
            } | null
            fallbackLinkText: {
              __typename?: 'RioLabel'
              en: string | null
              de: string | null
            }
          }
        | {
            __typename: 'RioComponentGeolocation'
            componentId: string
            componentType: Types.RioComponentType
            dependingComponentIds: Array<string> | null
            domainIdentifier: Types.RioDomainIdentifier | null
            label: {
              __typename?: 'RioLabel'
              de: string | null
              en: string | null
            }
            latitudeLabel: {
              __typename?: 'RioLabel'
              en: string | null
              de: string | null
            } | null
            longitudeLabel: {
              __typename?: 'RioLabel'
              en: string | null
              de: string | null
            } | null
            latitudeTooltipLabel: {
              __typename?: 'RioLabel'
              en: string | null
              de: string | null
            } | null
            longitudeTooltipLabel: {
              __typename?: 'RioLabel'
              en: string | null
              de: string | null
            } | null
            viewLabel: {
              __typename?: 'RioLabel'
              en: string | null
              de: string | null
            } | null
          }
        | {
            __typename: 'RioComponentOptions'
            componentId: string
            componentType: Types.RioComponentType
            dependingComponentIds: Array<string> | null
            domainIdentifier: Types.RioDomainIdentifier | null
            multiValue: boolean | null
            label: {
              __typename?: 'RioLabel'
              de: string | null
              en: string | null
            }
            options: Array<{
              __typename?: 'RioOptionValue'
              value: string
              label: {
                __typename?: 'RioLabel'
                en: string | null
                de: string | null
              }
            }>
          }
        | {
            __typename: 'RioComponentPassFail'
            componentId: string
            componentType: Types.RioComponentType
            dependingComponentIds: Array<string> | null
            domainIdentifier: Types.RioDomainIdentifier | null
            preselectedValue: Types.RioPassFailValue | null
            label: {
              __typename?: 'RioLabel'
              de: string | null
              en: string | null
            }
            passFailValues: {
              __typename?: 'RioPassFailValues'
              pass: Types.RioPassFailValue
              fail: Types.RioPassFailValue
            }
            passLabel: {
              __typename?: 'RioLabel'
              en: string | null
              de: string | null
            }
            failLabel: {
              __typename?: 'RioLabel'
              en: string | null
              de: string | null
            }
            viewLabel: {
              __typename?: 'RioLabel'
              en: string | null
              de: string | null
            } | null
            description: {
              __typename?: 'RioLabel'
              en: string | null
              de: string | null
            } | null
          }
        | {
            __typename: 'RioComponentRadioButtonGroup'
            componentId: string
            componentType: Types.RioComponentType
            dependingComponentIds: Array<string> | null
            domainIdentifier: Types.RioDomainIdentifier | null
            label: {
              __typename?: 'RioLabel'
              de: string | null
              en: string | null
            }
            radioButtons: Array<{
              __typename?: 'RioRadioButton'
              value: string
              label: {
                __typename?: 'RioLabel'
                en: string | null
                de: string | null
              }
              viewLabel: {
                __typename?: 'RioLabel'
                en: string | null
                de: string | null
              }
            }>
          }
        | {
            __typename: 'RioComponentSimple'
            componentId: string
            componentType: Types.RioComponentType
            dependingComponentIds: Array<string> | null
            domainIdentifier: Types.RioDomainIdentifier | null
            label: {
              __typename?: 'RioLabel'
              de: string | null
              en: string | null
            }
            placeholder: {
              __typename?: 'RioLabel'
              de: string | null
              en: string | null
            } | null
          }
        | {
            __typename: 'RioComponentStaticValue'
            componentId: string
            componentType: Types.RioComponentType
            dependingComponentIds: Array<string> | null
            domainIdentifier: Types.RioDomainIdentifier | null
            staticValue: Types.RioStaticValue
            label: {
              __typename?: 'RioLabel'
              de: string | null
              en: string | null
            }
          }
        | {
            __typename: 'RioComponentStatus'
            componentId: string
            componentType: Types.RioComponentType
            dependingComponentIds: Array<string> | null
            domainIdentifier: Types.RioDomainIdentifier | null
            statusOptions: Array<Types.RioStatusOptions>
            label: {
              __typename?: 'RioLabel'
              de: string | null
              en: string | null
            }
          }
        | {
            __typename: 'RioComponentTextArea'
            componentId: string
            componentType: Types.RioComponentType
            dependingComponentIds: Array<string> | null
            domainIdentifier: Types.RioDomainIdentifier | null
            label: {
              __typename?: 'RioLabel'
              de: string | null
              en: string | null
            }
            caption: {
              __typename?: 'RioLabel'
              de: string | null
              en: string | null
            } | null
            placeholder: {
              __typename?: 'RioLabel'
              de: string | null
              en: string | null
            } | null
          }
        | {
            __typename: 'RioComponentTroublemaker'
            componentId: string
            componentType: Types.RioComponentType
            dependingComponentIds: Array<string> | null
            domainIdentifier: Types.RioDomainIdentifier | null
            troublemakerOptions: Array<Types.RioTroublemakerOptions>
            label: {
              __typename?: 'RioLabel'
              de: string | null
              en: string | null
            }
          }
      >
      editSections: Array<{
        __typename?: 'RioSection'
        sectionId: string
        componentIds: Array<string>
        label: {
          __typename?: 'RioLabel'
          de: string | null
          en: string | null
        } | null
      }>
      viewSections: Array<{
        __typename?: 'RioSection'
        sectionId: string
        componentIds: Array<string>
        width: Types.RioSectionWidth | null
        label: {
          __typename?: 'RioLabel'
          de: string | null
          en: string | null
        } | null
      }>
      rules: Array<{
        __typename?: 'RioRule'
        componentId: string | null
        sectionId: string | null
        rule: Types.RioRuleDefinition
        otherComponentId: string | null
        otherComponentValue: string | null
        label: {
          __typename?: 'RioLabel'
          de: string | null
          en: string | null
        } | null
      }> | null
    }>
  }
}

export type RioListViewConfigFragment = {
  __typename?: 'RioListViewConfig'
  tenant: string
  category: Types.RioCategory
  columns: Array<{
    __typename?: 'RioListViewColumnMapping'
    columnType: Types.RioListViewColumnType
    initialSortColumn: Types.SortOrder | null
    componentIdValue: Array<string> | null
    componentIdLink: Array<string> | null
    reportAttribute: string | null
    columnSize: number
    label: { __typename?: 'RioLabel'; en: string | null; de: string | null }
  }>
  filters: Array<{
    __typename?: 'RioListViewFilter'
    componentType: Types.RioComponentType
    domainIdentifier: Types.RioDomainIdentifier | null
    showSelectedLabel: boolean | null
    label: { __typename?: 'RioLabel'; en: string | null; de: string | null }
    filterConfigs: Array<{
      __typename?: 'RioFilterConfig'
      value: string
      label: { __typename?: 'RioLabel'; en: string | null; de: string | null }
    }> | null
  }>
}

export type RioListViewColumnMappingFragment = {
  __typename?: 'RioListViewColumnMapping'
  columnType: Types.RioListViewColumnType
  initialSortColumn: Types.SortOrder | null
  componentIdValue: Array<string> | null
  componentIdLink: Array<string> | null
  reportAttribute: string | null
  columnSize: number
  label: { __typename?: 'RioLabel'; en: string | null; de: string | null }
}

export const RioListViewColumnMappingFragmentDoc = gql`
    fragment rioListViewColumnMapping on RioListViewColumnMapping {
  columnType
  initialSortColumn
  componentIdValue
  componentIdLink
  reportAttribute
  label {
    en
    de
  }
  columnSize
}
    `
export const RioListViewConfigFragmentDoc = gql`
    fragment rioListViewConfig on RioListViewConfig {
  tenant
  category
  columns {
    ...rioListViewColumnMapping
  }
  filters {
    componentType
    domainIdentifier
    label {
      en
      de
    }
    filterConfigs {
      label {
        en
        de
      }
      value
    }
    showSelectedLabel
  }
}
    `
export const RioReportsDocument = gql`
    query RioReports($input: RioReportsInput!) {
  rioReports(input: $input) {
    reports {
      ...rioReducedReport
    }
    listViewConfig {
      ...rioListViewConfig
    }
    usedTemplates {
      ...rioTemplate
    }
  }
}
    ${RioReducedReportFragmentDoc}
${RioUserFragmentDoc}
${RioBackofficeUserFragmentDoc}
${RioEmployeeFragmentDoc}
${RioAttachmentFragmentDoc}
${RioListViewConfigFragmentDoc}
${RioListViewColumnMappingFragmentDoc}
${RioTemplateFragmentDoc}
${RioComponentSimpleFragmentDoc}
${RioComponentDateFragmentDoc}
${RioComponentTextAreaFragmentDoc}
${RioComponentStatusFragmentDoc}
${RioComponentPassFailFragmentDoc}
${RioComponentCheckboxFragmentDoc}
${RioComponentStaticValueFragmentDoc}
${RioComponentTroublemakerFragmentDoc}
${RioComponentOptionsFragmentDoc}
${RioComponentGeolocationFragmentDoc}
${RioComponentExternalLinkFragmentDoc}
${RioComponentDateTimeFragmentDoc}
${RioComponentRadioButtonGroupFragmentDoc}
${RioRuleFragmentDoc}`

/**
 * __useRioReportsQuery__
 *
 * To run a query within a React component, call `useRioReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRioReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRioReportsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRioReportsQuery(
  baseOptions: Apollo.QueryHookOptions<
    RioReportsQuery,
    RioReportsQueryVariables
  > &
    (
      | { variables: RioReportsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<RioReportsQuery, RioReportsQueryVariables>(
    RioReportsDocument,
    options,
  )
}
export function useRioReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RioReportsQuery,
    RioReportsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<RioReportsQuery, RioReportsQueryVariables>(
    RioReportsDocument,
    options,
  )
}
// @ts-ignore
export function useRioReportsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RioReportsQuery,
    RioReportsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<RioReportsQuery, RioReportsQueryVariables>
export function useRioReportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RioReportsQuery,
        RioReportsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RioReportsQuery | undefined,
  RioReportsQueryVariables
>
export function useRioReportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RioReportsQuery,
        RioReportsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<RioReportsQuery, RioReportsQueryVariables>(
    RioReportsDocument,
    options,
  )
}
export type RioReportsQueryHookResult = ReturnType<typeof useRioReportsQuery>
export type RioReportsLazyQueryHookResult = ReturnType<
  typeof useRioReportsLazyQuery
>
export type RioReportsSuspenseQueryHookResult = ReturnType<
  typeof useRioReportsSuspenseQuery
>
export type RioReportsQueryResult = Apollo.QueryResult<
  RioReportsQuery,
  RioReportsQueryVariables
>
